import React, { useState, useEffect, useRef } from 'react';
import clsx from 'clsx';
import SoccerViewBroadcast from './broadcast';
import style from './style.module.scss';
import { observer } from 'mobx-react';

const SoccerViewRegular = observer(({ item }) => {
  const eventListRef = useRef();
  const {
    gameStatus,
    broadcasts,
    getProgressTime,
    timeLineTimerWidth,
    period,
    getFinishTime,
    checkExtraTime
  } = item;
  const { soccerTime } = getProgressTime;
  const [initAnimation, setInitAnimation] = useState(false);

  useEffect(() => {
    if (!initAnimation) {
      setTimeout(() => {
        setInitAnimation(true);
      });
    }
  }, []);

  return (
    <>
      <div className={clsx(style.info, checkExtraTime && style.overtime)}>
        <span className={style.first_half}>전반</span>
        <span className={style.second_half}>후반</span>
        <span className={style.overtime_first_half}>연장</span>
        {/* <span className={style.overtime_second_half}>연 (후)</span> */}
      </div>
      <div className={clsx(style.score_progress, period > 2 && style.overtime)}>
        <div className={style.time_progress}>
          <div
            className={style.timer}
            style={{ width: initAnimation ? `${timeLineTimerWidth}%` : 0 }}
          ></div>
        </div>
        <div className={style.event_list} ref={eventListRef}>
          {broadcasts.length > 0 &&
            broadcasts.map((item, idx) => (
              <SoccerViewBroadcast
                item={item}
                key={`${idx}-${period}-${item.locationType}-${item.displayTime}`}
                style={style}
                gameStatus={gameStatus}
                soccerTime={soccerTime}
                period={period}
                eventListRef={eventListRef}
                idx={idx}
                finishTime={getFinishTime}
                checkExtraTime={checkExtraTime}
              />
            ))}
        </div>
      </div>
    </>
  );
});

export default SoccerViewRegular;
